module.exports = __webpack_public_path__ + "img/wazdan.25a386f5.svg";